// extracted by mini-css-extract-plugin
module.exports = {"body":"ManaCurvePanel_body__nezCp"};